module.exports = __webpack_public_path__ + "img/banner3.a1e9042e.png";